import { render, staticRenderFns } from "./ContactInfos.vue?vue&type=template&id=13fcfbd9&"
import script from "./ContactInfos.vue?vue&type=script&lang=js&"
export * from "./ContactInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports